<template>
  <div
    class="w-full pt-12"
    ref="buildYourOwnAppWrap">
    <div
      class="w-full"
      v-if="!state.builderIsLoaded">
      Builder is loading...
    </div>
    <div
      class="bottom-section hidden-print"
      v-if="state.heaterDefaultConfig !== undefined"
      v-show="state.builderIsLoaded">
      <div class="w-full !px-3 md:!px-7">
        <div
          id="build-your-own"
          class="product-builder-container">
          <h3>
            Build Your Own
            <span class="product-icon build-your-own-white"> Build Your Own </span>
          </h3>

          <input
            type="hidden"
            name="builder_catID"
            id="builder_catID"
            :value="state.heaterDefaultConfig.builder_catID" />
          <input
            type="hidden"
            name="pre_selected_ids"
            id="pre_selected_ids"
            :value="state.heaterDefaultConfig.pre_selected_ids" />

          <strong>New!</strong> You can now configure multiple builds and send them all in the same quote request. Use the "SAVE" button below to save
          a build.
          <p v-if="state.heaterDefaultConfig.builder_summary.length > 0">
            {{ state.heaterDefaultConfig.builder_summary }}
          </p>

          <div class="saved-builds">
            <h4
              id="saved-builds-toggle"
              data-toggle="collapse"
              href="#savedBuilds">
              You have <span class="num_builds">0</span>
              saved builds
              <span
                class="glyphicon glyphicon-chevron-down"
                aria-hidden="true"></span>
            </h4>
            <div
              id="savedBuilds"
              class="collapse">
              <table>
                <thead class="hide-mobile">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">Label</th>
                    <th scope="col">Product</th>
                    <th scope="col">Build #</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
              <input
                type="submit"
                title="Send Inquiry"
                name="calculate"
                class="btn btn-calculate"
                id="builder-send-inquiry2"
                value="Send Inquiry"
                data-toggle="modal"
                data-target="#get-a-quote-modal" />
              <span class="wrap-mobile">Check the saved builds you would like a quote on then click the button.</span>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-8">
              <div
                class="product-code"
                id="product_code_designation">
                MY BUILD#:
                <span
                  v-if="state.heaterDefaultConfig.series_designation"
                  class="code"
                  id="type-1-code"
                  :data-preset-value="state.heaterDefaultConfig.series_designation"
                  >{{ state.heaterDefaultConfig.series_designation }}</span
                >
                <span
                  v-if="state.heaterDefaultConfig.series_designation"
                  class="code-divider"
                  >-</span
                >
                <div
                  style="float: right"
                  id="builder-clear">
                  <span
                    class="glyphicon glyphicon-remove"
                    aria-hidden="true"></span>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <input
                type="submit"
                style="background-color: #ea1f2e; border-color: #ea1f2e; text-transform: uppercase"
                name="calculate"
                class="btn btn-calculate col-xs-12"
                id="builder-send-inquiry"
                value="Submit to receive quote"
                data-toggle="modal"
                data-target="#get-a-quote-modal" />
              <input
                title="Save"
                type="submit"
                name="save"
                class="btn btn-calculate col-xs-12"
                id="builder-save-build"
                value="Save for later (not submitted)"
                style="background-color: #848484; border-color: #848484; text-transform: uppercase" />
            </div>
          </div>

          <div class="row builder-options desktop-builder">
            <div
              v-for="type in state.heaterDefaultConfig.types"
              :key="type.typeID"
              :class="`col-sm-${type.cols}`">
              <div
                class="option-container builder-type"
                :data-type-id="type.typeID"
                :id="`builder-type-${type.typeID}`">
                <input
                  type="hidden"
                  :title="`${type} option`"
                  class="builder-type-value"
                  :id="`builder-type-${type.typeID}-value`"
                  value="" />
                <h4>{{ type.type }}</h4>
                <ul class="option-list">
                  <li
                    v-for="option in type.options"
                    :key="option.optID"
                    :data-option-code="option.option_code"
                    :data-option-id="option.optID"
                    :data-type-id="type.typeID"
                    :id="`builder-option-${option.optID}`"
                    class="builder-option">
                    {{ option.option }}
                  </li>
                </ul>
              </div>
            </div>
            <div
              v-if="state.heaterDefaultConfig.builder_upgrade_options !== undefined && state.heaterDefaultConfig.builder_upgrade_options.length > 0"
              class="col-sm-4 product-updgrade-options">
              <div class="option-container builder-type">
                <input
                  type="hidden"
                  title="Builder Upgrade Options"
                  class="builder-type-value"
                  :id="`builder-upgrade-options-value`"
                  value="" />
                <h4>Upgrade Options</h4>
                <ul class="option-list">
                  <li
                    style="height: auto"
                    v-for="(option, index) in state.heaterDefaultConfig.builder_upgrade_options"
                    :key="`upgrade-option_${index}`">
                    <div class="checkbox">
                      <input
                        title="{builder_upgrade_options:upgrade_option}"
                        type="checkbox"
                        :id="`upgrade-option_${index}`"
                        :data-upgrade="`Upgrade - ${option}`"
                        data-option-code="upgrade"
                        class="builder-option" />
                      <label :for="`upgrade-option_${index}`">
                        {{ option }}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="mobile-builder row"
            style="display: none">
            <div
              id="collapseOneBuilder"
              class="panel-collapse collapse in"
              role="tabpanel">
              <div class="panel-body">
                <div
                  role="tabpanel"
                  class="tabs-left row">
                  <div class="col-xs-5 hidden-print">
                    <!-- Nav tabs -->
                    <ul
                      class="nav nav-tabs"
                      role="tablist">
                      <li
                        v-for="type in state.heaterDefaultConfig.types"
                        :key="type.typeID"
                        role="presentation">
                        <a
                          :href="`#builder-tab-${slugify(type.type)}`"
                          aria-controls="home"
                          role="tab"
                          data-toggle="tab">
                          {{ type.type }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-xs-7">
                    <div class="tab-content">
                      <div
                        v-for="type in state.heaterDefaultConfig.types"
                        :key="type.typeID"
                        role="tabpanel"
                        class="tab-pane"
                        :id="`builder-tab-${slugify(type.type)}`">
                        <div
                          class="option-container builder-type"
                          :data-type-id="type.typeID"
                          :id="`builder-type-${type.typeID}`">
                          <input
                            :title="`${type.type} option`"
                            type="hidden"
                            class="builder-type-value"
                            :id="`builder-type-${type.typeID}-value`"
                            value="" />
                          <h4>{{ type.type }}</h4>
                          <ul class="option-list">
                            <li
                              v-for="option in type.options"
                              :key="option.optID"
                              :data-option-code="option.option_code"
                              :data-option-id="option.optID"
                              :data-type-id="type.typeID"
                              :id="`builder-option-${option.optID}`"
                              :class="`builder-option mobile-builder-option-${option.optID}`">
                              {{ option.option }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <input
                title="Submit"
                type="submit"
                name="save"
                class="btn btn-calculate col-xs-12"
                id="builder-save-build_bottom"
                value="Save" />
            </div>
          </div>
        </div>
        <p class="cta-dyh">
          <span>?</span> Not sure if this is the right solution for you? Use our
          <a href="/standard-products/determine-your-heater">Determine Your Heater</a> tool to see which heaters meet your needs.
        </p>
      </div>
    </div>
    <div
      class="modal fade"
      id="save-build-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="save-build-modal"
      aria-hidden="true"
      style="display: none">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h2
              class="modal-title"
              id="contact-form-for-byo-modal-label">
              Save Build - <span class="product-name"></span> <span class="built-number"></span>
            </h2>
          </div>
          <div class="modal-body">
            <form action="">
              <div class="row">
                <div class="col-xs-6 col-sm-6">
                  <div class="form-group flip-label">
                    <input
                      type="text"
                      class="form-control"
                      id="save-build-label"
                      name="save-build-label" />
                    <label for="save-build-label">Label</label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <input
              type="submit"
              name="save"
              class="btn btn-calculate"
              id="save-build-submit"
              value="Save" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { WebsiteApiHelper } from '@/helpers/global/baseAPI.helper';
import { FarnamProductBuilder } from '@/helpers/website/farnam-custom/buildYourOwn.helper';
import GlobalHelper from '@/helpers/global/global.helper';

const buildYourOwnAppWrap = ref(null);

const state = reactive({
  builderIsLoaded: false as boolean,
  heaterCategoryId: '' as string,
  heaterPreselectedOptionId: '' as string,
  heaterDefaultConfig: undefined as any,
});

const slugify = (string: string) => {
  if (string !== null) {
    return GlobalHelper.slugify(string);
  } else {
    return '';
  }
};

const loadAndRunScripts = () => {
  let jQueryScriptCheckInterval = setInterval(() => {
    if (typeof $ !== 'undefined') {
      setTimeout(() => {
        const ProductBuilder = new FarnamProductBuilder();
        ProductBuilder.init();
        setTimeout(() => {
          state.builderIsLoaded = true;
        }, 100);
      }, 100);

      clearInterval(jQueryScriptCheckInterval);
    }
  }, 100);
};

const getHeaterDefaultConfig = () => {
  if (state.heaterCategoryId.length > 0) {
    WebsiteApiHelper.get(
      `/byo/get_init_data/?cat_id=${state.heaterCategoryId}${
        state.heaterPreselectedOptionId.length > 0 ? '&pre_selected_ids=' + state.heaterPreselectedOptionId : ''
      }`
    ).then((response) => {
      if (response !== undefined) {
        state.heaterDefaultConfig = response;
        localStorage.setItem('builderControllerOptionLinkLSKey', String(response.builder_controller_option_link));
      }
    });
  }
};

const getInfoFromDataAttrs = () => {
  if (buildYourOwnAppWrap.value !== null) {
    const dataAttrHeaterCategory = buildYourOwnAppWrap.value.parentElement.getAttribute('data-heater-category');
    if (dataAttrHeaterCategory !== null && dataAttrHeaterCategory.length > 0) {
      state.heaterCategoryId = dataAttrHeaterCategory;
    }

    const dataAttrHeaterPreselectedOption = buildYourOwnAppWrap.value.parentElement.getAttribute('data-heater-preselected-option');
    if (dataAttrHeaterPreselectedOption !== null && dataAttrHeaterPreselectedOption.length > 0) {
      state.heaterPreselectedOptionId = dataAttrHeaterPreselectedOption;
    }

    getHeaterDefaultConfig();
  }
};

onMounted(() => {
  getInfoFromDataAttrs();
  loadAndRunScripts();
});
</script>

<style lang="scss">
@import '@/styles/website/farnam-custom/build-your-own.scss';
</style>
